import { MdArrowForwardIos } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
export const SeeAll = (props) => {
  const navigate = useNavigate();

  return (
    <div className='flex flex-row justify-between'>
      <h1 className='font-semibold text-p-bk text-[18px] font-pin'>
        {props.name}
      </h1>
      {props.seeAll ? (
        <div className='flex flex-row gap-2 items-center'>
          <p className='text-p-bk text-base'>See All </p>
          <div className='bg-f-bk px-2 py-2 rounded-md text-b-mc hover:text-p-wh hover:bg-b-mc'>
            <MdArrowForwardIos
              onClick={() => navigate('/transactionhistory')}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};
